import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "col-md-6 mt-4" }
const _hoisted_4 = { class: "col mb-3" }
const _hoisted_5 = { class: "col mb-3" }
const _hoisted_6 = { class: "col mb-3" }
const _hoisted_7 = { class: "col mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_9 = { class: "col-md-12 mb-3" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "mb-3 mt-1" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-12 mb-md-25" }
const _hoisted_19 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "border border-primary mb-10" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = {
  key: 0,
  class: "text-muted ms-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "row g-3",
        "validation-schema": _ctx.schema,
        onSubmit: _ctx.sendOuvFer
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Date d'ouverture "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "dateOuverture",
                class: "form-control shadow-none fs-md-15 text-black",
                type: "datetime-local",
                max: _ctx.currentDateTime,
                modelValue: _ctx.dateOuverture,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOuverture) = $event)),
                readonly: ""
              }, null, 8, ["max", "modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateOuverture",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "soldeTheorique" }, "Fonds de caisse initial ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "soldeTheorique",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.soldeTheorique) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.soldeTheorique]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "reliquatTotalRetourner" }, "Reliquat à retourner ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "reliquatTotalRetourner",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reliquatTotalRetourner) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.reliquatTotalRetourner]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "caisse" }, "Caisse", -1)),
              _createVNode(_component_Field, { name: "caisse" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: _ctx.caisse,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.caisse) = $event)),
                    options: _ctx.caisseOptions,
                    "preserve-search": true,
                    multiple: false,
                    searchable: true,
                    placeholder: "Sélectionner la caisse",
                    label: "label",
                    "track-by": "value"
                  }, field, { onChange: _ctx.handleCaisseChange }), null, 16, ["modelValue", "options", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "caisse",
                class: "text-danger"
              }),
              (_ctx.caisseOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Aucune caisse affectée à cet utilisateur. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Personnes présentes à l'ouverture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: _ctx.user,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user) = $event)),
                      options: _ctx.userOptions,
                      searchable: true,
                      "track-by": "value",
                      mode: "tags",
                      label: "label",
                      placeholder: "Sélectionner la personne"
                    }, field), null, 16, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Observation ", -1)),
                _createVNode(_component_Field, {
                  name: "observations",
                  as: "textarea",
                  cols: "30",
                  rows: "12",
                  placeholder: "Entrer votre observation",
                  class: "form-control shadow-none rounded-0 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "observations",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary top-end",
                disabled: _ctx.caisseOptions.length === 0 || _ctx.isSubmitting
              }, [
                (_ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createTextVNode(" Ouvrir "))
              ], 8, _hoisted_14),
              _createVNode(_component_router_link, {
                to: "/OuverturesFermetures/",
                type: "button",
                class: "btn btn-danger mx-1"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Annuler")
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", {
                        class: "row d-flex align-items-center justify-content-between fw-bold py-2",
                        style: {"background-color":"#0a59a4"}
                      }, [
                        _createElementVNode("div", { class: "col-md-7" }, [
                          _createElementVNode("h3", { class: "fs-4 text-white" }, "Billetage")
                        ])
                      ], -1)),
                      _createElementVNode("div", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-2" }, [
                          _createElementVNode("div", { class: "col-md-3" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Monnaie")
                          ]),
                          _createElementVNode("div", { class: "col-md-3" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Quantité")
                          ]),
                          _createElementVNode("div", { class: "col-md-3" }, [
                            _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Montant")
                          ])
                        ], -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "container m-3"
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                  name: "monnaie",
                                  placeholder: "Sélectionner la monnaie",
                                  "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                  readonly: "",
                                  class: "form-control"
                                }, null, 8, _hoisted_24), [
                                  [_vModelText, billetage.libelle]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_Field, {
                                  name: `billetageList[${index}].qteBillet`,
                                  type: "number",
                                  min: "0",
                                  placeholder: "Entrer la quantité",
                                  class: "form-control",
                                  modelValue: billetage.qteBillet,
                                  "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                  onInput: event => _ctx.handleBilletageInput(event, billetage),
                                  onKeypress: _ctx.restrictInput
                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "onKeypress"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: `billetageList[${index}].qteBillet`,
                                  class: "text-danger"
                                }, null, 8, ["name"])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                  placeholder: "Montant",
                                  readonly: "",
                                  class: "form-control"
                                }, null, 8, _hoisted_27), [
                                  [_vModelText, billetage.montant]
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        (_ctx.billetageList.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Aucune donnée de billetage disponible. Veuillez saisir les quantités manuellement. "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])
    ])
  ]))
}